import React, { useState } from "react";
import { Icon, SecondaryButton } from "@prestosports/commons-ui";
import Printer32 from "@carbon/icons-react/lib/printer/32";
import Printable from "./Printable";
import SettingsDefinitionsSheet from "./SettingsDefinitionsSheet";

/**
 * Prints the definitions for whichever ruleset the event or season is on
 * (PSTATS-1267, criterion 2). Reuses Printable / react-to-print, the same path
 * the box score prints by, so the browser's own dialog covers "saved" as PDF.
 *
 * Rendered by EventSettings and SeasonSettings rather than passed through
 * Configuration's secondaryActions, because that slot is inside canEdit() on
 * the event form and would take the button away once the game starts, which is
 * when a rules reference is worth most.
 */
const SettingsDefinitionsButton = ({
	sections = [],
	ruleSetName,
	heading,
	title,
	fileName
}) => {
	const [printing, setPrinting] = useState(false);

	if (!sections.length) {
		return null;
	}

	return (
		<>
			<SecondaryButton
				id="button-setting-definitions"
				label="Definitions"
				startIcon={
					<Icon>
						<Printer32 />
					</Icon>
				}
				disabled={printing}
				onClick={() => setPrinting(true)}
			/>
			<Printable
				showPreview={printing}
				onAfterPrint={() => setPrinting(false)}
				fileName={fileName}
			>
				<SettingsDefinitionsSheet
					heading={heading}
					title={title}
					ruleSetName={ruleSetName}
					sections={sections}
				/>
			</Printable>
		</>
	);
};

export default SettingsDefinitionsButton;
